import { render, staticRenderFns } from "./partenaires.vue?vue&type=template&id=7ca0c45a"
import script from "./partenaires.vue?vue&type=script&lang=js"
export * from "./partenaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/app/components/Breadcrumb.vue').default,PartnerLocatorSearch: require('/app/components/PartnerLocatorSearch.vue').default,PartnerLocatorNearest: require('/app/components/PartnerLocatorNearest.vue').default,PartnerLocatorItem: require('/app/components/PartnerLocatorItem.vue').default,PartnerLocatorMap: require('/app/components/PartnerLocatorMap.vue').default,PartnerLocatorDirectory: require('/app/components/PartnerLocatorDirectory.vue').default})
